<template>
	<ResourcePlanningChart
		:project-id="projectId"
		:retainer-period-id="retainerPeriodId"
	/>
</template>

<script lang="ts" setup>
import { ResourcePlanningChart } from '@/features/ResourcePlanning';
import { type Project } from '@/generated/graphql';

defineProps<{
	projectId: Project['id'];
	retainerPeriodId: number | undefined;
}>();
</script>
